<template>
  <v-timeline-item
    small
    fill-dot
    :color="colorTimelineItem"
  >
    <v-row class="d-flex align-center">
      <v-col cols="auto">
        <span :class="`headline font-weight-bold ${colorTimelineItem}--text text-h6`">
          Status: {{ item.statusNome }}
        </span>
      </v-col>

      <v-col cols="auto">
        <span>
          Fila: {{ item.filaNome }}
        </span>
      </v-col>

      <v-col cols="auto">
        <span>
          Alterado por: {{ item.nomeUsuarioAlteracao }}
        </span>
      </v-col>

      <v-col cols="auto">
        <span>
          Data: {{ functions.converterDateTimeStringEmLocaleDateTimeString(item.dataAlteracao) }}
        </span>
      </v-col>
    </v-row>
  </v-timeline-item>
</template>

<script>
import { computed } from '@vue/composition-api'
import { converterDateTimeStringEmLocaleDateTimeString } from '@/utils/dateTime'

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    indice: {
      type: Number,
      required: true,
      validator: v => v >= 0,
    },
  },

  setup(props) {
    const coresTimelineItem = ['primary', 'warning', 'info', 'success', 'error']

    /** Só existem 5 resultados possíveis: 0, 1, 2, 3 e 4, mesmo quando o índice é maior do que a quantidade de elementos */
    const colorTimelineItem = computed(() => coresTimelineItem[props.indice % coresTimelineItem.length])

    /** O índice é dividio por dois pois só considero duas orientações: start (left) e end (right) */
    const orientacaoTimelineItem = computed(() => (props.indice % 2 === 0 ? 'align-start' : 'align-end'))

    return {
      colorTimelineItem,
      orientacaoTimelineItem,
      functions: {
        converterDateTimeStringEmLocaleDateTimeString,
      },
    }
  },
}
</script>
